import React, { useEffect, useState } from 'react';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import UsersFilters from './Filters/UsersFilters';
import "./People.css";
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import PanelsUserControlBudgtes from './PanelsUserControlBudgtes/PanelsUserControlBudgtes';
import Panel from 'Components/Panel/Panel';
import GetUserId from 'Components/UserLogged/UserId/UserId';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelsUserControl from './PanelsUserControl/PanelsUserControl';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';

const People = () => {
    useEffect(() => {
        document.title = "Redech | Usuários"
    }, [])

    const userIdLogged = GetUserId();
    const [benefitsIdSelected, setBenefitsIdSelected] = useState([]);
    const [employeeSectorIdSelected, setEmployeeSectorIdSelected] = useState(null);
    const [workScheduleIdSelected, setworkScheduleIdSelected] = useState([]);
    const [sectorEmployees, setSectorsEmployees] = useState(null);
    const [usersSelected, setUsersSelected] = useState([]);
    const [resetUserList, setResetUserList] = useState(false);

    useEffect(() => {
        async function getSectorIdByLoggedEmployee() {
            if (userIdLogged) {
                const parameters = { userId: userIdLogged }
                const employeeData = await ExecuteAxios.api('get', `/employee/employee-by-userId/`, { params: parameters });
                const sectorId = employeeData ? employeeData.sectorId : '';
                if (sectorId) {
                    setEmployeeSectorIdSelected(sectorId);
                }
            }
        };

        getSectorIdByLoggedEmployee();
    }, [])

    const PanelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '80%',
        maxHeight: '80%',
    };

    const PanelFilterStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '20%',
        maxHeight: '20%',
        borderBottom: 'solid 2px #ccc',
    };


    return (
        <>
            <LayoutDefault>
                <Panel style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <Panel style={{ display: 'flex', flexDirection: 'column' }} className={'main-modal two left'}>
                        <Panel style={PanelFilterStyle}>
                            <LoadingIndicator loaded={userIdLogged}>
                                <UsersFilters
                                    onUpdateSectorsEmployees={val => { setSectorsEmployees(val) }}
                                    onUpdateUserSelected={val => { setUsersSelected(val) }}
                                    onUpdateResetUserList={val => { setResetUserList(val) }}
                                    onUpdateSectorIdSelected={val => { setEmployeeSectorIdSelected(val) }}
                                    onUpdateBenefitsIdSelected={val => { setBenefitsIdSelected(val) }}
                                    onUpdateIdSelected={val => { setUsersSelected(val) }}
                                    idsSelected={usersSelected}
                                    employeeSectorIdSelected={employeeSectorIdSelected}
                                    resetUserList={resetUserList}
                                />
                            </LoadingIndicator>
                        </Panel>

                        <LoadingIndicator loaded={sectorEmployees}>
                            <Panel style={PanelListStyle}
                                usersSelect={usersSelected}
                                canViewCRUD={true}
                            >
                                <PanelListDefault
                                    onUpdateIdSelected={val => { setUsersSelected(val) }}
                                    idsSelected={usersSelected}
                                    data={sectorEmployees} />
                            </Panel>
                        </LoadingIndicator>

                    </Panel>
                    <Panel style={{ display: 'flex', flexDirection: 'column' }} className={'main-modal two right'}>
                        <Panel style={{
                            width: '100%',
                            maxHeight: '42%',
                            minHeight: '42%',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <PanelsUserControl
                                onUpdateResetUserList={val => { setResetUserList(val) }}
                                onUpdateUserSelected={val => { setUsersSelected(val) }}
                                usersSelected={usersSelected}
                            />
                        </Panel>
                        <Panel style={{
                            width: '100%',
                            maxHeight: '58%',
                            minHeight: '58%',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <PanelsUserControlBudgtes
                                onUpdateResetUserList={val => { setResetUserList(val) }}
                                onUpdateUserSelected={val => { setUsersSelected(val) }}
                                onUpdateBenefitsIdSelected={val => { setBenefitsIdSelected(val) }}
                                benefitsIdSelected={benefitsIdSelected}
                                workScheduleIdSelected={workScheduleIdSelected}
                                onUpdateWorkScheduleIdSelected={setworkScheduleIdSelected}
                                usersSelected={usersSelected}
                            />
                        </Panel>
                    </Panel>
                </Panel>
            </LayoutDefault>
        </>
    );
};

export default People;
